var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{attrs:{"title":"Sản phẩm chưa ghép"}},[_c('div',[_c('CustomTable',{attrs:{"items":_vm.items,"fields":_vm.fields,"custom-link":("channel/sync-" + _vm.channel),"channel":_vm.channel,"add_new_button":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }